import React from 'react';

export default (WrappedComponent) => {
  return class extends React.Component {
    componentDidMount () {
      document.body.className = 'background-white';
    }

    componentWillUnmount () {
      document.body.className = '';
    }

    render () {
      return <WrappedComponent {...this.props} />;
    }
  };
};
